import React from "react"
import IconCard from './IconCard';
import CustomSlider from './CustomSlider';
import { styled } from "../../../stitches.config";
import { ReactComponent as UopIcon } from '../../../assets/img/natemat/career/uop_b2b.svg?react';
import { ReactComponent as PakietIcon } from '../../../assets/img/natemat/career/pakiet_benefitow.svg?react';
import { ReactComponent as RozwojIcon } from '../../../assets/img/natemat/career/rozwoj_osobisty.svg?react';
import { ReactComponent as HybrydowaIcon } from '../../../assets/img/natemat/career/praca_hybrydowa.svg?react';
import { ReactComponent as WyjazdyIcon } from '../../../assets/img/natemat/career/mozliwosc_wyjazdow.svg?react';
import { ReactComponent as ZespolIcon } from '../../../assets/img/natemat/career/ciekawy_zespol.svg?react';

const settings = {
    dots: true,
    infinite: false,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
};

interface CardProps {
    icon?: string;
    title: string;
    description: string;
}

interface Props {
    isDesktop?: boolean,
    content: {
        icon?: string;
        title: string;
        description: string;
    }[],
}

const Benefits = (props: Props) => {

    const items = props.content

    function get_icon(icon_name: string | undefined): JSX.Element | string {
        switch (icon_name) {
            case "AGREEMENT_ICON":
                return <UopIcon />
            case "TRIPS_ICON":
                return <WyjazdyIcon />
            case "TEAM_ICON":
                return <ZespolIcon />
            case "HYBRID_WORK_ICON":
                return <HybrydowaIcon />
            case "PERSONAL_DEVELOPMENT_ICON":
                return <RozwojIcon />
            case "BENEFITS_ICON":
                return <PakietIcon />
            default:
                return icon_name ? icon_name.toString() : 'icon';
        }
    }

    const cards = items.map((item: CardProps, index: number) => { return (<IconCard text={item.description} title={item.title} key={index}>{get_icon(item.icon)}</IconCard>) })
    const format = props.isDesktop ? <div className='benefits-grid'>{cards}</div> : <CustomSlider {...settings} className='benefits-slider'>{cards}</CustomSlider>

    return (
        <BenefitsWrapper>
            {format}
        </BenefitsWrapper>
    )
}

export default Benefits

const BenefitsWrapper = styled('div', {
    color: '$grayscale100',
    '@bp4': {
        // maxWidth: 'min-content',
        alignSelf: 'center',
    }
})